import { Pipe, PipeTransform } from '@angular/core';
import { measureTextWidth } from '../utils/dom.utils';

@Pipe({
  name: 'textWidth',
  standalone: true,
})
export class TextWidthPipe implements PipeTransform {
  transform(text: string, font = '16px Arial', padding = 0): number {
    return measureTextWidth(text, font) + padding;
  }
}
